/* eslint-disable array-callback-return */
import React from "react";
import NavItem from "./NavItem";
import { navbarItems } from "../../helpers/data/navbar";
import { useDispatch, useSelector } from "react-redux";
import logo from "../../assets/images/logo2.svg";
import settings from "../../assets/images/icons/settings.svg";
import logoutIcon from "../../assets/images/icons/logout.svg";
import { Link, useHistory } from "react-router-dom";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { logout } from "../../store/actions/userActions";
import { checkPermissions } from "../../helpers/authentication/checkPermissions";

const Sidebar = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const permissions = useSelector(state => state.auth.permissions) || [];

	const toggleResponsiveMenu = () => {
		const sidebar = document.getElementById("sidebar");
		sidebar.classList.toggle("sidebar-responsive");
		const sidebarWrapper = document.getElementById("sm-wrapper");
		sidebarWrapper.classList.toggle("sm-wrapper-toggle");
	};

	const handleLogout = e => {
		e.preventDefault();
		dispatch(logout());
		cookie.remove("token");
		history.push("/login");
		toast.success("تم تسجيل خروجك بنجاح!");
	};

	return (
		<>
			<section className="sidebar" id="sidebar">
				<div className="logo">
					<a href="https://ejjadh.com/" target="_blank" rel="noreferrer">
						<img src={logo} alt="Ejjadh-logo" />
					</a>
				</div>
				<ul className="sidebar-menu list-inline text-center">
					{checkPermissions(["setting-list", "setting-edit"]) && (
						<>
							<li className="list-inline-item">
								<Link to="/settings">
									<img src={settings} alt="settings" />
								</Link>
							</li>
							<li className="list-inline-item">
								<Link to="/menu">
									<i className="fas fa-bars"></i>
								</Link>
							</li>
						</>
					)}
					<li className="list-inline-item">
						<button onClick={handleLogout} type="button">
							<img src={logoutIcon} alt="logout" />
						</button>
					</li>
				</ul>
				<div className="accordion" id="sidebar-menu">
					{navbarItems.map(item => {
						const itemPermissions = Array.isArray(item.permissions)
							? item.permissions
							: [];
						const found = permissions.some(
							r => itemPermissions.indexOf(r) >= 0
						);
						if (found || itemPermissions.includes("*")) {
							return (
								<NavItem
									item={item}
									key={item.id}
									userPermissions={permissions}
								/>
							);
						}
					})}
				</div>
			</section>
			<section
				className="sm-wrapper d-block d-sm-none"
				id="sm-wrapper"
				onClick={toggleResponsiveMenu}
			></section>
		</>
	);
};

export default Sidebar;
